import { render, staticRenderFns } from "./ReferralRecord.vue?vue&type=template&id=43a19f39&scoped=true&"
import script from "./ReferralRecord.vue?vue&type=script&lang=js&"
export * from "./ReferralRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReferralRecord.vue?vue&type=style&index=0&id=43a19f39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a19f39",
  null
  
)

export default component.exports